import { Bars } from 'react-loader-spinner';
import FullTableLayout from './FullTableLayout';
import ProjectJobsMonitor from '../production-management/ProjectJobsMonitor';
import { useJobs } from '../../features/jobs/hooks/useJobs';
import { FULL_TABLE_PARENTS } from './routes';

/**
 * The Projects table on its own page. ProjectMonitor feeds this component from
 * its own useJobs() call, so the standalone page does the same — React Query
 * dedupes the request, it is the same cache entry.
 */
const ProjectsFull = () => {
  const { data: jobs = [], isLoading, error } = useJobs();

  return (
    <FullTableLayout
      backTo={FULL_TABLE_PARENTS.projectMonitor}
      backLabel="Project Monitor"
    >
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: 320 }}
        >
          <Bars height="50" width="50" color="#3874ff" ariaLabel="loading" />
        </div>
      ) : error ? (
        <div className="p-4">
          <h4>Error</h4>
          <pre className="text-danger">{String(error?.message || error)}</pre>
        </div>
      ) : (
        <ProjectJobsMonitor jobs={jobs} fullPage />
      )}
    </FullTableLayout>
  );
};

export default ProjectsFull;
